import { SEARCH_NAME_FIELD } from './common/TemplateSearch/model'

export const getSearchDefaultValues = () => ({
  [SEARCH_NAME_FIELD]: '',
})
